module.exports = __webpack_public_path__ + "cc43c3fb1d50984d49d22980febeddc2.png";